import React, { useRef, useCallback } from 'react';
import { useId } from '@react-aria/utils';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import useMergedRef from '@react-hook/merged-ref';
import { Button } from '../button/index.js';
import { FileDropZone } from './file-drop-zone.js';
export const FileUploaderControl = React.forwardRef(({ startIcon = 'Add', variant = 'subtle', className, children, onPress, dataAutomation = 'file-uploader-control', isDisabled, isPressed, isFrozen, onFileSelect, isDragAndDropEnabled = false, dropZoneText = 'Drag and drop a file here, or', onChange, ...inputProps }, forwardedRef) => {
    const id = useId(inputProps.id);
    const inputRef = useRef(null);
    const triggerRef = useRef(null);
    const ref = useMergedRef(forwardedRef, inputRef);
    const handleChange = (e) => {
        onChange?.(e);
        const { files } = e.currentTarget;
        if (files)
            onFileSelect?.(Array.from(files));
    };
    const onPressHandler = useCallback((e) => {
        onPress?.(e);
        inputRef.current?.click();
    }, [inputRef.current, onPress]);
    const handleFileDrop = (items) => {
        if (items)
            onFileSelect?.(items.files);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FileDropZone, { isEnabled: !!isDragAndDropEnabled, hasError: false, onDrop: handleFileDrop, dropZoneText: dropZoneText },
            React.createElement(Button, { "data-automation": `${dataAutomation}/button`, startIcon: startIcon, variant: isDragAndDropEnabled ? 'secondaryOnGray' : variant, className: className, ref: triggerRef, children: children, onPress: onPressHandler, isDisabled: isDisabled, isPressed: isPressed, isFrozen: isFrozen, "aria-controls": id, "aria-labelledby": id }),
            React.createElement(VisuallyHidden, null,
                React.createElement("input", { "data-automation": `${dataAutomation}/input`, type: 'file', ref: ref, hidden: true, onChange: handleChange, ...inputProps, id: id })))));
});
//# sourceMappingURL=file-uploader-control.component.js.map